import { Text, TooltipCommonProps } from '@wix/design-system';
import React, { FC } from 'react';

import s from './styles.scss';

type HeaderTitleTypographyProps = {
  dataHook: string;
};

const tooltipProps: TooltipCommonProps = {
  size: 'small',
  placement: 'bottom',
};

export const HeaderTitleTypography: FC<HeaderTitleTypographyProps> = ({ children, dataHook }) => {
  return (
    <Text light dataHook={dataHook} ellipsis tooltipProps={tooltipProps} weight="normal">
      <span className={s.headerTitle}>{children}</span>
    </Text>
  );
};
